import { render, staticRenderFns } from "./SettingsRolePermissions.vue?vue&type=template&id=0f09ffd7"
import script from "./SettingsRolePermissions.vue?vue&type=script&lang=js"
export * from "./SettingsRolePermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f09ffd7')) {
      api.createRecord('0f09ffd7', component.options)
    } else {
      api.reload('0f09ffd7', component.options)
    }
    module.hot.accept("./SettingsRolePermissions.vue?vue&type=template&id=0f09ffd7", function () {
      api.rerender('0f09ffd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/SettingsRolePermissions.vue"
export default component.exports